var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3943 2.18543C13.3943 2.18543 12.2783 3.28093 10.0668 5.4924L8.51059 3.93618L11.8176 0.629204C10.0771 -0.415103 7.8451 -0.148907 6.39126 1.30493C5.26505 2.43115 4.8248 4.07951 5.23433 5.61526L5.26505 5.73812L0.084466 10.9187C-0.0281553 11.0313 -0.0281553 11.2156 0.084466 11.3282L2.66452 13.9185C2.77714 14.0311 2.96143 14.0311 3.07405 13.9185L8.25463 8.73794L8.37749 8.76866C9.903 9.17819 11.5514 8.74818 12.6878 7.61173C14.1417 6.15789 14.4079 3.92594 13.384 2.18543H13.3943Z",
    fill: "url(#paint0_linear_25084_66415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25084_66415",
    x1: 9.42634,
    y1: 14.003,
    x2: 4.57,
    y2: -0.0016593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3876",
    stopOpacity: 0.519832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D030DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.bc23e55e4402de3b3f8d46901d90956a.svg";
export { ForwardRef as ReactComponent };